export default __webpack_public_path__ + "static/media/values-seperator-arrow.03851652.svg";